import styled from 'styled-components'

const DEFAULT_COLORS = {
  warning: { color: 'var(--golden-yellow)', background: 'var(--clean-gray)' },
  error: { color: 'var(--bronze-gold)', background: 'var(--light-pink)' },
  info: { color: 'var(--pet-anjo-dark-blue)', background: 'var(--pet-anjo-light-blue)' },
  success: { color: 'var(--success)', background: 'var(--success-pastel)' },
  outline: { color: 'var(--cobasi-blue-light-8)', background: 'transparent', border: '1px solid var(--cobasi-blue-light-8)' },
  default: { color: 'var(--cobasi-blue-light-8)', background: 'var(--pet-anjo-lighter-blue)' },
  pending: { color: 'var(--golden-yellow)', background: 'var(--clean-gray)' },
  finished: { color: 'var(--gray-7)', background: 'var(--the-white)', border: '1px solid var(--neutral-darkish-gray)' },
  featured: { color: 'var(--coral-orange)', background: 'var(--coral-orange-light)' },
  disabled: { color: 'var(--gray-7)', background: 'var(--neutral-gray)' }
}

const OUTLINE_COLORS = {
  default: { color: 'var(--cobasi-blue-light-8)', background: 'transparent', border: '1px solid var(--cobasi-blue-light-8)' },
  warning: { color: 'var(--golden-yellow)', background: 'transparent', border: '1px solid var(--golden-yellow)' },
  error: { color: 'var(--bronze-gold)', background: 'transparent', border: '1px solid var(--bronze-gold)' },
  success: { color: 'var(--success)', background: 'var(--the-white)', border: '1px solid var(--success)' },
  disabled: { color: 'var(--gray-7)', background: 'var(--the-white)', border: '1px solid var(--neutral-gray)' }
}

export const Container = styled.div`
  display: flex;
  min-height: 23px;
  padding: 2px 8px;
  width: fit-content;
  align-items: center;
  gap: 5px;
  border-radius: 8px;
  font-family: var(--primary-font);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  margin: ${({ margin }) => margin || '0'};
  ${({ type, outline }) => {
    const COLOR_SELECTION = outline ? OUTLINE_COLORS : DEFAULT_COLORS
    return type ? COLOR_SELECTION[type] : COLOR_SELECTION.default
  }}
`
